'use strict';

(function () {
  'use strict';

  angular.module('vnext').component('msSleepReadout', {
    templateUrl: 'sleep/templates/sleep-readout.html',
    controller: SleepReadoutCtrl,
    controllerAs: 'vm',
    bindings: {
      notificationsEnabled: '<',
      onUpdateSettings: '&'
    }
  });
  SleepReadoutCtrl.$inject = ['$state', 'sleepEntrySvc', '$log', '$rootScope'];

  function SleepReadoutCtrl($state, sleepEntrySvc, $log, $rootScope) {
    var vm = this;
    vm.page = page;
    vm.currentPage = 0;
    vm.enableDiary = true;
    vm.enableNotifications = false;
    vm.staticLinks = $rootScope.staticLinks;

    vm.goToEntry = function (day) {
      $state.go('vnext.content.sleep.main.entry', { day: day });
    };

    vm.updateSettings = function () {
      vm.onUpdateSettings({ enableDiary: vm.enableDiary, enableNotifications: vm.enableNotifications });
    };

    vm.$onInit = function () {
      activate();
    };

    ///////////////////////////////
    function activate() {
      $log.debug('SleepReadoutCtrl activate');
      vm.enableNotifications = vm.notificationsEnabled;
      page(0).then(function (readout) {
        vm.completeWeek = readout.completeWeek;
      });
    }

    function page(direction) {
      vm.currentPage += direction;
      //user cannot go past current week (0)
      if (vm.currentPage > 0) {
        vm.currentPage = 0;
        return;
      }
      //get a week of entries, starting from yesterday
      var endDate = moment().subtract(1, 'days');
      if (vm.currentPage < 0) {
        endDate.subtract(Math.abs(vm.currentPage), 'weeks');
      }
      var startDate = endDate.clone().subtract(6, 'days');

      return sleepEntrySvc.getEntries(startDate, endDate, true).then(function (readout) {
        vm.readout = readout;
        vm.days = Object.keys(readout.entries);
        vm.days.sort();
        return readout;
      });
    }
  }
})();